import AssetMapper from "@components/AdvancedAdsetMapping/AssetMapper"

const AdvancedAdsetMappingPage = () => {
  return (
    <div className="max-w-7xl mx-auto">
      <AssetMapper />
    </div>
  )
}

export default AdvancedAdsetMappingPage
